// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__QVfz+","active":"Avatar_active__KV-QH","image":"Avatar_image__A0PIh","clickable":"Avatar_clickable__UFyWH","icon":"Avatar_icon__-eepL"};